import { BASE_SETTING_PRIORITIES } from 'api/digitalTwin/digitalTwinConstants'
import { useHasPermission } from 'helpers/global.helper/global.helper'
import {
  applySystemDisplayColors,
  getDeviationSettingPriorities,
} from 'helpers/settingPriority.helper/settingPriority.helper'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import DigitalTwinSettingsView from 'views/DigitalTwinSettingsView/DigitalTwinSettingsView'

export default function DigitalTwinCollectedSettingsView(): ReactElement {
  const { t } = useTranslation()
  const { activeSystem } = useAuth()

  const permissions = {
    canEdit: useHasPermission(`change_plan_settings`),
    canEditHistoric: useHasPermission(`change_historic_plan_settings`),
  }

  const systemPriorityLevels = activeSystem?.setting_priority_levels
  const collectedSettingPriorities = getDeviationSettingPriorities(systemPriorityLevels)

  return (
    <>
      <DigitalTwinSettingsView
        priorities={collectedSettingPriorities}
        baseSettingPriorities={applySystemDisplayColors(BASE_SETTING_PRIORITIES, systemPriorityLevels)}
        showCalendar={true}
        title={t(`Collected settings`)}
        calendarTitle={t(`Collected settings - calendar`)}
        tableTitle={t(`Collected settings - table`)}
        permissions={permissions}
        isCollectedSettings
      />
    </>
  )
}
